import React from 'react';
import { Link } from 'react-router-dom';

import { Icon, IconDelete, IconNewTab, IconWarningStrong } from '@flixbus/honeycomb-icons-react';
import { Button, Tag } from '@flixbus/honeycomb-react';

import { EB_OPERATOR_LABEL, RRO_OPERATOR_LABEL } from 'constants/crewDetails';

import styles from 'pages/RideDetails/components/DriverCard/styles.module.css';

const ReturnJobSection = ({
	selectedReturnJob,
	extraActionLabel,
	driverFullName,
	onSelectedReturnJobClick,
	onClearSelectedReturnJob,
	onExtraAction,
}) => {
	if (selectedReturnJob) {
		return (
			<>
				<button
					type="button"
					className={styles.selectedReturnJob}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onSelectedReturnJobClick?.();
					}}
				>
					<div className={styles.selectedReturnHeader}>
						<span>Return job selected:</span>
						<Button
							appearance="link"
							size="sm"
							display="square"
							aria-label="Clear selected return job"
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								onClearSelectedReturnJob?.();
							}}
						>
							<Icon InlineIcon={IconDelete} />
						</Button>
					</div>
					<div className={styles.selectedReturnTitle}>
						<span>{`Run: ${selectedReturnJob.runName}`}</span>
						<span>{`Job: ${selectedReturnJob.jobCode}`}</span>
					</div>
					<div className={styles.selectedReturnRoute}>{selectedReturnJob.route}</div>
				</button>

				{selectedReturnJob.assigneeName && selectedReturnJob.assigneeName !== driverFullName && (
					<div className={styles.reassignWarning}>
						<div className={styles.reassignWarningHeader}>
							<Icon InlineIcon={IconWarningStrong} size={4} />
							<span>Warning!</span>
						</div>
						<div className={styles.reassignWarningText}>
							This return job already has an assignee:
						</div>
						<div className={styles.reassignWarningAssignee}>
							<span className={styles.reassignWarningName}>{selectedReturnJob.assigneeName}</span>
							{selectedReturnJob.assigneeCurrentRun !== undefined && (
								<Tag display="outlined" small>
									{selectedReturnJob.assigneeCurrentRun === null
										? EB_OPERATOR_LABEL
										: RRO_OPERATOR_LABEL}
								</Tag>
							)}
							{selectedReturnJob.assigneeId && (
								<Link to={`/crew-management/${selectedReturnJob.assigneeId}`} target="_blank">
									<Icon InlineIcon={IconNewTab} size={3} />
								</Link>
							)}
						</div>
						<div className={styles.reassignWarningReplace}>
							Proceeding will replace them with <strong>{driverFullName}</strong>
						</div>
					</div>
				)}
			</>
		);
	}

	if (extraActionLabel) {
		return (
			<Button
				className={styles.extraActionBtn}
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					onExtraAction?.();
				}}
			>
				{extraActionLabel}
			</Button>
		);
	}

	return null;
};

export default ReturnJobSection;
